<template>
  <div class="product-summary px-4 px-md-6">
    <template v-if="errors.length && !isLoading">
      <div class="d-flex">
        <v-icon color="error">mdi-alert-decagram</v-icon>
        <div class="ml-3">
          <div v-for="(error, index) in errors" :key="index">{{ error }}</div>
        </div>
      </div>
    </template>
    <template v-else>
      <div v-if="summaryHTML" class="product-summary__description small d-none d-sm-inline-block">
        <v-skeleton-loader v-if="isLoading" type="list-item-two-line" class="pr-4" width="200"></v-skeleton-loader>
        <span v-else v-html="summaryHTML"></span>
      </div>
      <v-spacer class="d-none d-sm-inline-block" />
      <div class="product-summary__price ma-0 d-inline-block">
        <v-progress-circular v-if="isPriceLoading" color="primary" indeterminate />
        <template v-else-if="finalPrice">
          <div class="product-summary__price-amount text-nowrap">
            <ng-price
              class="d-inline-block"
              :amount="finalPrice.amount"
              :currency="finalPrice.currency"
              is-formatted
              :data-testid="finalPrice === price ? 'originalPrice' : undefined"
            />
            <ng-price
              class="d-inline-block ml-4 text-h6 font-weight-regular"
              v-if="finalPrice !== price"
              data-testid="originalPrice"
              :amount="price.amount"
              :currency="price.currency"
              is-crossed
              is-formatted
            />
          </div>
          <div
            v-if="productCoupon && productCouponStatus === 'success'"
            class="product-summary__price-coupon x-small text-muted text-nowrap"
          >
            {{ $t('product.promocodeApplied', [productCoupon.toUpperCase()]) }}
          </div>
        </template>
      </div>
      <ng-button
        class="ml-6"
        color="primary"
        x-large
        @click="$emit('submit')"
        :disabled="!price || !price.amount || isPriceLoading"
      >
        {{ $t('product.order') }}
      </ng-button>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import productService from '@/services/product/productService';

export default {
  name: 'ProductSummary',
  props: {
    errors: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('product', ['price', 'isPriceLoading']),
    ...mapState('promotions', ['productCoupon', 'productCouponStatus']),
    ...mapGetters('product', ['finalPrice', 'productDataFormatted']),
    summaryHTML() {
      return this.productDataFormatted && productService.getSummary(this.productDataFormatted);
    },
  },
};
</script>

<style lang="scss" scoped>
.product-summary {
  display: flex;
  padding-top: 12px;
  padding-bottom: 12px;
  border-top: 1px solid $border-color;
  border-bottom: 1px solid $border-color;
  justify-content: space-between;
  align-items: center;
  min-height: 76px;
  background-color: white;

  &::v-deep .product-summary__price-amount {
    font-size: 34px;
    line-height: 1;
    letter-spacing: -1px;
    font-weight: 500;

    @media (min-width: map-get($grid-breakpoints, 'lg')) {
      font-size: 48px;
      letter-spacing: -1.4px;
    }

    .ng-price__amount,
    .text-h6 {
      line-height: 1;
    }
  }
}
</style>
